__turbopack_context__.v({
  "cards-wrapper": "how-your-plan-works-module-scss-module__fiYqPq__cards-wrapper",
  "chevron-left": "how-your-plan-works-module-scss-module__fiYqPq__chevron-left",
  "chevron-right": "how-your-plan-works-module-scss-module__fiYqPq__chevron-right",
  "chevron-wrapper": "how-your-plan-works-module-scss-module__fiYqPq__chevron-wrapper",
  "container": "how-your-plan-works-module-scss-module__fiYqPq__container",
  "container-wrapper": "how-your-plan-works-module-scss-module__fiYqPq__container-wrapper",
  "left-filler": "how-your-plan-works-module-scss-module__fiYqPq__left-filler",
  "right-filler": "how-your-plan-works-module-scss-module__fiYqPq__right-filler",
  "title": "how-your-plan-works-module-scss-module__fiYqPq__title",
  "title-wrapper": "how-your-plan-works-module-scss-module__fiYqPq__title-wrapper",
});
